export default __webpack_public_path__ + "static/media/1_0106.0f2b89c1.webp";